import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';

import { IPositionCandidateTestTask } from '@types';
import { NotProvided } from 'components/common/NotProvided/NotProvided';

export const ScoreCell: React.FC<{
  testTask?: IPositionCandidateTestTask | null;
  label: string;
  plain?: boolean;
}> = ({ testTask, label, plain }) => {
  if (testTask === undefined) return <NotProvided field={`${label} scores`} />;

  if (testTask?.isPending)
    return (
      <Tooltip
        title={`No ${label} score yet — result on the way`}
        placement="top"
      >
        <Typography variant="body1" color="text.lightGrey">
          Pending
        </Typography>
      </Tooltip>
    );

  const score = testTask?.score;

  if (typeof score !== 'number')
    return (
      <Tooltip
        title={testTask ? `${label} not scored yet` : `No ${label} on file`}
        placement="top"
      >
        <Typography variant="body1" color="text.lightGrey">
          n/a
        </Typography>
      </Tooltip>
    );

  if (plain) return <Typography variant="body1">{score}%</Typography>;

  return (
    <Box
      component="span"
      sx={(theme) => ({
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: '2.75rem',
        px: 0.75,
        py: 0.25,
        borderRadius: 1,
        backgroundColor: theme.palette.highlight.neutral,
        color: theme.palette.text.primary,
        fontSize: '0.8125rem',
        fontWeight: 500,
        fontVariantNumeric: 'tabular-nums',
      })}
    >
      {score}%
    </Box>
  );
};
